import { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { createcocinaInsumo, updatecocinaInsumo, listcocinaInsumoLazy } from "../api/ventaCocinaInsumo";
import {
  listUnidadMedida014,
  listTipoItem011,
  listTributo015
} from "../api/hacienda";
import {
  FiPlus, FiSearch, FiEdit, FiTrash2, FiImage,
  FiPackage, FiUpload, FiCheckCircle, FiInfo
} from "react-icons/fi";
import Loader from "../components/Loader";

const Insumos = () => {
  const [loading, setLoading] = useState(true);
  const [insumos, setInsumos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [unidadesMedida, setUnidadesMedida] = useState([]);
  const [tipoItem, setTipoItem] = useState([]);
  const [tributo, setTributo] = useState([]);
  const [currentId, setCurrentId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [photoFile, setPhotoFile] = useState(null);
  const [imageModal, setImageModal] = useState({ show: false, url: "", name: "" });

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [buscar, setBuscar] = useState("");

  const [form, setForm] = useState({
    nombre: "",
    descripcion: "",
    precio: "",
    sku: "",
    photo: "",
    unidadMedida: "",
    tributo: "",
    tipoItem: "",
    status: 1,
    stock: 0,
  });

  const fetchData = async (p = 1) => {
    try {
      const data = await listcocinaInsumoLazy(p, limit, buscar);
      if (data) {
        setInsumos(data.data || []);
        setTotalPages(data.totalPages || 1);
        setPage(data.currentPage || 1);
      }
    } catch (error) {
      console.error("Error al obtener insumos", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page);
    // eslint-disable-next-line 
  }, [page, limit, buscar]);

  useEffect(() => {
    if (showModal) {
      listTipoItem011()
        .then((res) => setTipoItem(res.data || []))
        .catch((error) => console.error("Error al obtener tipo item", error))

      listUnidadMedida014()
        .then((res) => setUnidadesMedida(res.data || []))
        .catch((error) => console.error("Error al obtener unidades", error))

      listTributo015()
        .then((res) => setTributo(res.data || []))
        .catch((error) => console.error("Error al obtener tributos", error))
    }
  }, [showModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      setPhotoPreview(URL.createObjectURL(file));
      setForm(prev => ({ ...prev, photo: file.name }));
    }
  };

  const handleSelectChange = (value, name) => {
    setForm((prev) => ({ ...prev, [name]: value ? value.value : "" }));
  };

  const openModalForEdit = (insumo) => {
    setForm({
      nombre: insumo.name || "",
      descripcion: insumo.description || "",
      sku: insumo.sku || "",
      precio: insumo.price || "",
      photo: insumo.photo || "",
      unidadMedida: insumo.id_unidad_medida?.toString() || "",
      tipoItem: insumo.id_type_item?.toString() || "",
      tributo: insumo.id_tributo?.toString() || "",
      status: insumo.status !== undefined ? insumo.status : 1,
      stock: insumo.CocinaInsumoExistencia?.[0]?.stock || 0,
    });
    setCurrentId(insumo.id);
    setEditMode(true);
    setPhotoFile(null);
    if (insumo.photo) {
      setPhotoPreview(process.env.REACT_APP_RUTA_PRODUCTOS + insumo.photo);
    } else {
      setPhotoPreview(null);
    }
    setShowModal(true);
  };

  const openImageModal = (photo, name) => {
    if (!photo) return;
    const url = process.env.REACT_APP_RUTA_PRODUCTOS + photo;
    setImageModal({ show: true, url, name });
  };

  const handleSubmit = async (e) => {
    setSubmitting(true);
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("name", form.nombre);
      formData.append("description", form.descripcion);
      formData.append("sku", form.sku);
      formData.append("price", parseFloat(form.precio) || 0);
      formData.append("id_unidad_medida", form.unidadMedida);
      formData.append("id_type_item", form.tipoItem);
      formData.append("id_tributo", form.tributo);
      formData.append("status", parseInt(form.status));
      if (photoFile) {
        formData.append("photo", photoFile);
      }

      if (editMode) {
        await updatecocinaInsumo(currentId, formData);
      } else {
        await createcocinaInsumo(formData);
      }

      setShowModal(false);
      fetchData(page);
    } catch (error) {
      console.error("Error al guardar el insumo", error);
    } finally {
      setSubmitting(false);
    }
  };

  const opcionesUnidades = unidadesMedida.map((u) => ({
    value: u.id.toString(),
    label: `${u.codigo} | ${u.name}`,
  }));

  const opcionesItems = tipoItem.map((i) => ({
    value: i.id.toString(),
    label: `${i.codigo} | ${i.name}`,
  }));

  const opcionesTributo = tributo.map((t) => ({
    value: t.id.toString(),
    label: `${t.codigo} | ${t.name}`,
  }));

  const opcionesEstado = [
    { value: "1", label: "Activo" },
    { value: "0", label: "Inactivo" },
  ];

  return (
    <div className="p-3 sm:p-6 max-w-7xl mx-auto">
      {/* Encabezado */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 sm:mb-6 gap-3">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800">Catálogo de Insumos</h2>
          <p className="text-xs sm:text-sm text-slate-500 mt-1">Administre los insumos y materias primas para recetas</p>
        </div>
        <button
          onClick={() => {
            setEditMode(false);
            setForm({
              nombre: "",
              descripcion: "",
              precio: "",
              sku: "",
              number_part: "",
              photo: "",
              unidadMedida: "",
              tipoItem: "",
              tributo: "",
              status: 1,
              stock: 0,
            });
            setPhotoFile(null);
            setPhotoPreview(null);
            setShowModal(true);
          }}
          className="w-full sm:w-auto bg-indigo-600 text-white px-4 py-2.5 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm shadow-indigo-200 font-medium flex items-center justify-center gap-2"
        >
          <FiPlus size={20} />
          Agregar Insumo
        </button>
      </div>

      {/* Filtros */}
      <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-3 mb-4 sm:mb-6 bg-white p-3 sm:p-4 rounded-xl shadow-sm border border-slate-200">
        <div className="relative flex-grow">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FiSearch className="h-5 w-5 text-slate-400" />
          </div>
          <input
            type="text"
            placeholder="Buscar insumo por SKU, nombre..."
            value={buscar}
            onChange={(e) => {
              setBuscar(e.target.value);
              setPage(1);
            }}
            className="pl-10 pr-4 py-2 w-full border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors bg-slate-50 focus:bg-white text-sm"
          />
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-500 font-medium whitespace-nowrap">Mostrar:</span>
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            className="border border-slate-300 rounded-lg px-3 py-2 bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
          >
            {[10, 15, 25, 50, 100].map(num => (
              <option key={num} value={num}>
                {num} registros
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden relative">
        {loading && (
          <div className="absolute inset-0 bg-white/70 flex justify-center items-center z-10">
            <Loader />
          </div>
        )}

        {/* Tabla desktop */}
        <div className="hidden md:block overflow-x-auto custom-scrollbar">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase border-b border-slate-200">
              <tr>
                <th className="px-4 py-3 font-semibold">Foto</th>
                <th className="px-4 py-3 font-semibold">Sku</th>
                <th className="px-4 py-3 font-semibold">Nombre</th>
                <th className="px-4 py-3 font-semibold">Precio</th>
                <th className="px-4 py-3 font-semibold">Unidad Medida</th>
                <th className="px-4 py-3 font-semibold text-center">Existencia</th>
                <th className="px-4 py-3 font-semibold text-center">Estado</th>
                <th className="px-4 py-3 font-semibold text-center sticky right-0 bg-slate-100 border-l border-slate-200 z-10 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.05)]">Opciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {insumos.map((i) => (
                <tr key={i.id} className="hover:bg-indigo-50/50 transition-colors group">
                  <td className="px-4 py-3">
                    <div
                      onClick={() => openImageModal(i.photo, i.name)}
                      className="w-10 h-10 rounded-lg border border-slate-200 bg-white flex items-center justify-center overflow-hidden shrink-0 cursor-zoom-in hover:border-indigo-400 hover:ring-4 hover:ring-indigo-50 transition-all group/img"
                    >
                      {i.photo ? (
                        <img
                          src={`${process.env.REACT_APP_RUTA_PRODUCTOS}${i.photo}`}
                          alt={i.name}
                          className="w-full h-full object-contain group-hover/img:scale-110 transition-transform"
                        />
                      ) : (
                        <FiImage className="w-5 h-5 text-slate-300" />
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-slate-600 font-mono text-xs">{i.sku || "---"}</td>
                  <td className="px-4 py-3 text-slate-700 font-medium whitespace-nowrap">{i.name}</td>
                  <td className="px-4 py-3 text-indigo-600 font-semibold whitespace-nowrap">${i.price}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{i.UnidadMedida?.name || "---"}</td>
                  <td className="px-4 py-3 text-center">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${(i.CocinaInsumoExistencia?.[0]?.stock || 0) <= 5 ? 'bg-rose-100 text-rose-700' : 'bg-emerald-100 text-emerald-700'}`}>
                      {i.CocinaInsumoExistencia?.[0]?.stock || 0}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border ${String(i.status) === "1" ? 'bg-emerald-50 text-emerald-600 border-emerald-200' : 'bg-rose-50 text-rose-600 border-rose-200'}`}>
                      {String(i.status) === "1" ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center sticky right-0 bg-slate-100 group-hover:bg-slate-200 border-l border-slate-200 z-0 transition-colors">
                    <button
                      type="button"
                      onClick={() => openModalForEdit(i)}
                      className="bg-white border border-slate-200 text-slate-600 px-3 py-1.5 rounded-lg hover:bg-slate-50 hover:text-indigo-600 transition-colors text-xs font-medium"
                    >
                      <FiEdit className="inline mr-1" /> Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Móvil cards */}
        <div className="md:hidden divide-y divide-slate-100">
          {insumos.map((i) => (
            <div key={i.id} className="p-4">
              <div className="flex items-start gap-4 mb-4">
                <div
                  onClick={() => openImageModal(i.photo, i.name)}
                  className="w-16 h-16 rounded-xl border border-slate-200 bg-white flex items-center justify-center overflow-hidden shrink-0 active:scale-95 transition-transform cursor-pointer"
                >
                  {i.photo ? (
                    <img
                      src={`${process.env.REACT_APP_RUTA_PRODUCTOS}${i.photo}`}
                      alt={i.name}
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <FiImage className="w-6 h-6 text-slate-300" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-slate-800 text-sm mb-1">{i.name}</p>
                  <p className="text-[10px] text-slate-400 font-mono bg-slate-50 px-2 py-0.5 rounded inline-block">
                    SKU: {i.sku || "N/A"}
                  </p>
                </div>
                <div className="shrink-0">
                  <p className="text-emerald-600 font-bold text-sm">${i.price}</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => openModalForEdit(i)}
                className="w-full bg-slate-50 border border-slate-200 text-slate-600 py-2 rounded-lg text-xs font-medium"
              >
                Editar Insumo
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Paginación — Siempre Visible */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mt-4 sm:mt-6 px-1 gap-3">
        <p className="text-sm text-slate-500">
          Página <span className="font-medium text-slate-700">{page}</span> de <span className="font-medium text-slate-700">{totalPages}</span>
        </p>
        <div className="flex gap-1 bg-white p-1 rounded-lg border border-slate-200 overflow-x-auto justify-center">
          <button
            disabled={page === 1}
            onClick={() => fetchData(page - 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === 1 ? "text-slate-400 cursor-not-allowed" : "text-slate-600 hover:bg-slate-100"}`}
          >
            ← Ant
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
            <button
              key={num}
              onClick={() => fetchData(num)}
              className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === num ? "bg-indigo-50 text-indigo-600" : "text-slate-600 hover:bg-slate-100"}`}
            >
              {num}
            </button>
          ))}
          <button
            disabled={page === totalPages}
            onClick={() => fetchData(page + 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === totalPages ? "text-slate-400 cursor-not-allowed" : "text-slate-600 hover:bg-slate-100"}`}
          >
            Sig →
          </button>
        </div>
      </div>

      {/* Modal principal */}
      {showModal && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-start sm:items-center z-[100] p-2 sm:p-6 overflow-y-auto">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl flex flex-col my-4 sm:my-8 animate-fade-in-up">
            <div className="flex items-center justify-between p-4 sm:p-6 border-b border-slate-100">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0">
                  <FiPackage size={20} />
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  {editMode ? "Actualizar Insumo" : "Registrar Nuevo Insumo"}
                </h3>
              </div>
              <button onClick={() => setShowModal(false)} className="text-slate-400 hover:text-slate-600 p-1">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-4 sm:p-6 overflow-y-auto custom-scrollbar max-h-[65vh]">
              <form onSubmit={handleSubmit} id="insumo-form" className="space-y-6">

                {/* Imagen */}
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 flex flex-col sm:flex-row items-center gap-6">
                  <div className="w-28 h-28 bg-white rounded-lg border-2 border-dashed border-slate-200 flex items-center justify-center p-2 overflow-hidden shrink-0">
                    {photoPreview ? (
                      <img src={photoPreview} alt="Preview" className="max-w-full max-h-full object-contain" />
                    ) : (
                      <FiImage className="w-8 h-8 text-slate-300" />
                    )}
                  </div>
                  <div className="flex-1 text-center sm:text-left space-y-2">
                    <h4 className="text-sm font-bold text-slate-800">Imagen del Insumo</h4>
                    <p className="text-xs text-slate-500 mb-3">PNG, JPG (Máximo 2MB)</p>
                    <label className="cursor-pointer inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-slate-300 hover:border-indigo-500 hover:text-indigo-600 rounded-lg text-xs font-semibold transition-all">
                      <FiUpload className="w-4 h-4" />
                      <span>Subir Imagen</span>
                      <input type="file" className="hidden" accept="image/*" onChange={handlePhotoChange} />
                    </label>
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">SKU</label>
                    <input
                      type="text"
                      name="sku"
                      value={form.sku}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Nombre</label>
                    <input
                      type="text"
                      name="nombre"
                      value={form.nombre}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Precio de Costo ($)</label>
                    <input
                      type="number"
                      step="0.0001"
                      name="precio"
                      value={form.precio}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Unidad de Medida</label>
                    <ReactSelect
                      options={opcionesUnidades}
                      value={opcionesUnidades.find((opt) => opt.value === form.unidadMedida) || null}
                      onChange={(val) => handleSelectChange(val, "unidadMedida")}
                      placeholder="Seleccione..."
                      className="text-sm"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Estado</label>
                    <ReactSelect
                      options={opcionesEstado}
                      value={opcionesEstado.find((opt) => String(opt.value) === String(form.status)) || null}
                      onChange={(val) => handleSelectChange(val, "status")}
                      className="text-sm"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">
                       Existencia 
                       <span className="text-[10px] text-red-500 font-normal ml-2">(Lectura)</span>
                    </label>
                    <input
                      type="number"
                      name="stock"
                      value={form.stock || 0}
                      readOnly
                      className="w-full border border-slate-200 bg-slate-50 text-slate-500 rounded-lg px-4 py-2.5 cursor-not-allowed text-sm"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Tipo Item</label>
                    <ReactSelect
                      options={opcionesItems}
                      value={opcionesItems.find((opt) => opt.value === form.tipoItem) || null}
                      onChange={(val) => handleSelectChange(val, "tipoItem")}
                      placeholder="Seleccione..."
                      className="text-sm"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Tributo</label>
                    <ReactSelect
                      options={opcionesTributo}
                      value={opcionesTributo.find((opt) => opt.value === form.tributo) || null}
                      onChange={(val) => handleSelectChange(val, "tributo")}
                      placeholder="Seleccione..."
                      className="text-sm"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                  <div className="col-span-full">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Descripción</label>
                    <textarea
                      name="descripcion"
                      value={form.descripcion}
                      onChange={handleChange}
                      rows="2"
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 text-sm"
                    ></textarea>
                  </div>
                </div>
              </form>
            </div>

            <div className="p-4 sm:p-6 border-t border-slate-100 bg-slate-50 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-3 rounded-b-2xl">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="w-full sm:w-auto px-5 py-2.5 rounded-lg border border-slate-300 text-slate-700 font-medium hover:bg-white text-sm"
                disabled={submitting}
              >
                Cancelar
              </button>
              <button
                type="submit"
                form="insumo-form"
                disabled={submitting}
                className="w-full sm:w-auto px-6 py-2.5 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 text-sm flex items-center justify-center gap-2"
              >
                {submitting && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>}
                {editMode ? "Actualizar Insumo" : "Guardar Insumo"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Imagen Ampliada — Estilo Productos.jsx */}
      {imageModal.show && (
        <div
          className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-slate-900/90 backdrop-blur-sm animate-fade-in"
          onClick={() => setImageModal({ ...imageModal, show: false })}
        >
          <button 
            className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors p-2"
            onClick={() => setImageModal({ ...imageModal, show: false })}
          >
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div
            className="relative max-w-4xl w-full flex flex-col items-center gap-4 animate-zoom-in"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-white p-2 rounded-2xl shadow-2xl overflow-hidden max-h-[80vh] flex items-center justify-center">
              <img 
                src={imageModal.url} 
                alt={imageModal.name} 
                className="max-w-full max-h-[75vh] object-contain"
              />
            </div>
            <div className="bg-white/10 backdrop-blur-md px-6 py-2 rounded-full border border-white/20">
              <p className="text-white font-bold text-lg">{imageModal.name}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Insumos;
